import { render, staticRenderFns } from "./TermsList.vue?vue&type=template&id=e643fa5e&scoped=true"
import script from "./TermsList.vue?vue&type=script&lang=js"
export * from "./TermsList.vue?vue&type=script&lang=js"
import style0 from "./TermsList.vue?vue&type=style&index=0&id=e643fa5e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e643fa5e",
  null
  
)

export default component.exports